import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';
export function useCurrentUser() {
    const accessToken = useAuthStore((s) => s.accessToken);
    return useQuery({
        queryKey: ['auth', 'me'],
        queryFn: async () => (await api.get('/auth/me/')).data,
        enabled: Boolean(accessToken),
        staleTime: 60_000,
    });
}
export function useMyCompanies() {
    const accessToken = useAuthStore((s) => s.accessToken);
    return useQuery({
        queryKey: ['auth', 'me', 'companies'],
        queryFn: async () => (await api.get('/tenants/me/companies/')).data,
        enabled: Boolean(accessToken),
        staleTime: 60_000,
    });
}
export function usePermissions() {
    const accessToken = useAuthStore((s) => s.accessToken);
    const activeCompanyId = useAuthStore((s) => s.activeCompanyId);
    return useQuery({
        queryKey: ['auth', 'me', 'permissions', activeCompanyId],
        queryFn: async () => (await api.get('/auth/me/permissions/')).data,
        enabled: Boolean(accessToken && activeCompanyId),
        staleTime: 30_000,
    });
}
/** Invalidate everything that depends on the active company. */
export function useInvalidateOnCompanySwitch() {
    const qc = useQueryClient();
    return () => {
        qc.invalidateQueries({ queryKey: ['auth', 'me', 'permissions'] });
        qc.invalidateQueries({ predicate: (q) => q.queryKey[0] !== 'auth' });
    };
}
